import authActionType from "./authActionTypes";

const refreshTokenPending = () => ({
  type: authActionType.REFRESH_TOKEN_PENDING,
});

const refreshTokenSuccess = (token) => ({
  type: authActionType.REFRESH_TOKEN_SUCCESS,
  data: token,
});

const refreshTokenError = (message) => ({
  type: authActionType.REFRESH_TOKEN_ERROR,
  data: message,
});

const changeLanguage = (lang) => ({
  type: authActionType.CHANGE_LANGUAGE,
  lang: lang,
});

const setUserInfo = (info) => ({
  type: authActionType.REFRESH_TOKEN_SET_USER_INFO,
  data: info,
});

export default {
  refreshTokenPending,
  refreshTokenSuccess,
  refreshTokenError,
  changeLanguage,
  setUserInfo,
};
